import React from 'react';
import styled from 'styled-components';

const LabelText = styled.p`
  font-size: 16px;
  text-align: center;
  color: #444444;
  margin-top: 64px;
`;

export const PlanningLabel = () => {
  return (
    <LabelText>
      Planning data may not be up to date. Please contact your advisor with any questions and/or to
      update your data.
    </LabelText>
  );
};
